import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import "bootstrap/dist/css/bootstrap.min.css"
import "rc-switch/assets/index.css"
import "react-input-range/lib/css/index.css"
import "react-perfect-scrollbar/dist/css/styles.css"
import "react-big-calendar/lib/css/react-big-calendar.css"
import 'react-image-lightbox/style.css'
import 'react-tagsinput/react-tagsinput.css'
import 'react-date-picker/dist/DatePicker.css'
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css'

import {storage, defaultTheme} from "./constants/defaultValues"

try {
    localStorage.getItem(storage.cookie_settings)
} catch (e) {
    alert("Váš prohlížeč blokuje cookies které jsou potřebné pro správnou funkci stránky. Povolte cookies a aktualizujte stránku.")
}

const theme = localStorage.getItem(storage.theme) || defaultTheme

localStorage.setItem(storage.theme, theme)

let render = () => {
    import('./assets/css/sass/themes/app.' + theme + '.scss').then(x => {
        require('./AppRenderer')
    })
}
render()